var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { KeyType } from '@interfaces/keys.interface';
import { CustomJsonUtils } from '@popup/steem/utils/custom-json.utils';
import { SteemEngineUtils } from '@popup/steem/utils/steem-engine.utils';
import { SteemTxUtils } from '@popup/steem/utils/steem-tx.utils';
import Config from 'src/config';
/* istanbul ignore next */
const stakeToken = (to, symbol, amount, activeKey, username, options) => {
    return SteemEngineUtils.sendOperation([TokensUtils.getStakeTokenOperation(to, symbol, amount, username)], activeKey, options);
};
/* istanbul ignore next */
const getStakeTokenOperation = (to, symbol, amount, username) => {
    const json = {
        contractName: 'tokens',
        contractAction: 'stake',
        contractPayload: { to: to, symbol: symbol, quantity: amount },
    };
    return CustomJsonUtils.getCustomJsonOperation(json, username, KeyType.ACTIVE, Config.steemEngine.mainnet);
};
/* istanbul ignore next */
const getStakeTokenTransaction = (to, symbol, amount, username) => {
    return SteemTxUtils.createTransaction([
        TokensUtils.getStakeTokenOperation(to, symbol, amount, username),
    ]);
};
/* istanbul ignore next */
const unstakeToken = (symbol, amount, activeKey, username, options) => {
    return SteemEngineUtils.sendOperation([TokensUtils.getUnstakeTokenOperation(symbol, amount, username)], activeKey, options);
};
/* istanbul ignore next */
const cancelUnstakeToken = (transactionId, activeAccount, options) => {
    return SteemEngineUtils.sendOperation([
        TokensUtils.getCancelUnstakeTokenOperation(transactionId, activeAccount.name),
    ], activeAccount.keys.active, options);
};
const getCancelUnstakeTokenOperation = (transactionId, username) => {
    const json = {
        contractName: 'tokens',
        contractAction: 'cancelUnstake',
        contractPayload: { txId: transactionId },
    };
    return CustomJsonUtils.getCustomJsonOperation(json, username, KeyType.ACTIVE, Config.steemEngine.mainnet);
};
/* istanbul ignore next */
const getUnstakeTokenOperation = (symbol, amount, username) => {
    const json = {
        contractName: 'tokens',
        contractAction: 'unstake',
        contractPayload: { symbol: symbol, quantity: amount },
    };
    return CustomJsonUtils.getCustomJsonOperation(json, username, KeyType.ACTIVE, Config.steemEngine.mainnet);
};
/* istanbul ignore next */
const getUnstakeTokenTransaction = (symbol, amount, username) => {
    return SteemTxUtils.createTransaction([
        TokensUtils.getUnstakeTokenOperation(symbol, amount, username),
    ]);
};
/* istanbul ignore next */
const delegateToken = (to, symbol, amount, activeKey, username, options) => {
    return SteemEngineUtils.sendOperation([TokensUtils.getDelegateTokenOperation(to, symbol, amount, username)], activeKey, options);
};
/* istanbul ignore next */
const getDelegateTokenOperation = (to, symbol, amount, username) => {
    const json = {
        contractName: 'tokens',
        contractAction: 'delegate',
        contractPayload: { to: to, symbol: symbol, quantity: amount },
    };
    return CustomJsonUtils.getCustomJsonOperation(json, username, KeyType.ACTIVE, Config.steemEngine.mainnet);
};
/* istanbul ignore next */
const getDelegateTokenTransaction = (to, symbol, amount, username) => {
    return SteemTxUtils.createTransaction([
        TokensUtils.getDelegateTokenOperation(to, symbol, amount, username),
    ]);
};
/* istanbul ignore next */
const cancelDelegationToken = (from, symbol, amount, activeKey, username, options) => {
    return SteemEngineUtils.sendOperation([
        TokensUtils.getCancelDelegationTokenOperation(from, symbol, amount, username),
    ], activeKey, options);
};
/* istanbul ignore next */
const getCancelDelegationTokenOperation = (from, symbol, amount, username) => {
    const json = {
        contractName: 'tokens',
        contractAction: 'undelegate',
        contractPayload: { from: from, symbol: symbol, quantity: amount },
    };
    return CustomJsonUtils.getCustomJsonOperation(json, username, KeyType.ACTIVE, Config.steemEngine.mainnet);
};
/* istanbul ignore next */
const getCancelDelegationTokenTransaction = (from, symbol, amount, username) => {
    return SteemTxUtils.createTransaction([
        TokensUtils.getCancelDelegationTokenOperation(from, symbol, amount, username),
    ]);
};
/* istanbul ignore next */
const sendToken = (currency, to, amount, memo, activeKey, username, options) => {
    return SteemEngineUtils.sendOperation([TokensUtils.getSendTokenOperation(currency, to, amount, memo, username)], activeKey, options);
};
/* istanbul ignore next */
const getSendTokenOperation = (currency, to, amount, memo, username) => {
    const json = {
        contractName: 'tokens',
        contractAction: 'transfer',
        contractPayload: {
            symbol: currency,
            to: to,
            quantity: amount,
            memo: memo,
        },
    };
    return CustomJsonUtils.getCustomJsonOperation(json, username, KeyType.ACTIVE, Config.steemEngine.mainnet);
};
/* istanbul ignore next */
const getSendTokenTransaction = (currency, to, amount, memo, username) => {
    return SteemTxUtils.createTransaction([
        TokensUtils.getSendTokenOperation(currency, to, amount, memo, username),
    ]);
};
const getHiveEngineTokenPrice = ({ symbol }, market) => {
    const tokenMarket = market.find((t) => t.symbol === symbol);
    const price = tokenMarket
        ? parseFloat(tokenMarket.lastPrice)
        : symbol === 'SWAP.STEEM'
            ? 1
            : 0;
    return price;
};
const getSteemEngineTokenValue = (balance, steem = { usd: 1 }, tokens) => {
    const token = tokens === null || tokens === void 0 ? void 0 : tokens.find((t) => t.symbol === balance.symbol);
    const totalToken = parseFloat(balance.balance) +
        parseFloat(balance.pendingUndelegations) +
        parseFloat(balance.pendingUnstake) / ((token === null || token === void 0 ? void 0 : token.numberTransactions) || 1) +
        parseFloat(balance.delegationsOut) +
        parseFloat(balance.stake);
    return totalToken * (steem === null || steem === void 0 ? void 0 : steem.usd);
};
/* istanbul ignore next */
const getUserBalance = (account) => {
    return SteemEngineUtils.get({
        contract: 'tokens',
        table: 'balances',
        query: { account: account },
        indexes: [],
        limit: 1000,
        offset: 0,
    });
};
/* istanbul ignore next */
const getIncomingDelegations = (symbol, username) => __awaiter(void 0, void 0, void 0, function* () {
    return SteemEngineUtils.get({
        contract: 'tokens',
        table: 'delegations',
        query: { to: username, symbol: symbol },
        indexes: [],
        limit: 1000,
        offset: 0,
    });
});
/* istanbul ignore next */
const getOutgoingDelegations = (symbol, username) => __awaiter(void 0, void 0, void 0, function* () {
    return SteemEngineUtils.get({
        contract: 'tokens',
        table: 'delegations',
        query: { from: username, symbol: symbol },
        indexes: [],
        limit: 1000,
        offset: 0,
    });
});
/* istanbul ignore next */
/**
 * SSCJS request using HiveEngineConfigUtils.getApi().find.
 * @param {string} contract Fixed as 'tokens'
 * @param {string} table Fixed as 'tokens
 */
const getAllTokens = () => __awaiter(void 0, void 0, void 0, function* () {
    let tokens = [];
    let offset = 0;
    do {
        const newTokens = yield getTokens(offset);
        tokens.push(...newTokens);
        offset += 1000;
    } while (tokens.length % 1000 === 0);
    return tokens;
});
const getTokens = (offset) => __awaiter(void 0, void 0, void 0, function* () {
    return (yield SteemEngineUtils.get({
        contract: 'tokens',
        table: 'tokens',
        query: {},
        limit: 1000,
        offset: offset,
        indexes: [],
    })).map((t) => {
        return Object.assign(Object.assign({}, t), { metadata: JSON.parse(t.metadata) });
    });
});
const getTokenInfo = (symbol) => __awaiter(void 0, void 0, void 0, function* () {
    return (yield SteemEngineUtils.get({
        contract: 'tokens',
        table: 'tokens',
        query: { symbol: symbol },
        limit: 1000,
        offset: 0,
        indexes: [],
    })).map((t) => {
        return Object.assign(Object.assign({}, t), { metadata: JSON.parse(t.metadata) });
    })[0];
});
const getPendingUnstakes = (account) => __awaiter(void 0, void 0, void 0, function* () {
    return SteemEngineUtils.get({
        contract: 'tokens',
        table: 'pendingUnstakes',
        query: { account },
        limit: 1000,
        offset: 0,
        indexes: [],
    });
});
/* istanbul ignore next */
/**
 * SSCJS request using HiveEngineConfigUtils.getApi().find.
 * @param {string} contract Fixed as 'market'
 * @param {string} table Fixed as 'metrics
 */
const getTokensMarket = (query, limit, offset, indexes) => __awaiter(void 0, void 0, void 0, function* () {
    return SteemEngineUtils.get({
        contract: 'market',
        table: 'metrics',
        query: query,
        limit: limit,
        offset: offset,
        indexes: indexes,
    });
});
const getTokenPrecision = (symbol) => __awaiter(void 0, void 0, void 0, function* () {
    if (symbol === 'SBD' || symbol === 'STEEM') {
        return 3;
    }
    const token = yield getTokenInfo(symbol);
    return token.precision;
});
const TokensUtils = {
    sendToken,
    stakeToken,
    unstakeToken,
    delegateToken,
    cancelDelegationToken,
    getUserBalance,
    getIncomingDelegations,
    getOutgoingDelegations,
    getAllTokens,
    getTokensMarket,
    getHiveEngineTokenValue: getSteemEngineTokenValue,
    getStakeTokenOperation,
    getUnstakeTokenOperation,
    getDelegateTokenOperation,
    getCancelDelegationTokenOperation,
    getSendTokenOperation,
    getStakeTokenTransaction,
    getUnstakeTokenTransaction,
    getDelegateTokenTransaction,
    getCancelDelegationTokenTransaction,
    getSendTokenTransaction,
    getHiveEngineTokenPrice,
    getTokenInfo,
    getTokenPrecision,
    getPendingUnstakes,
    cancelUnstakeToken,
    getCancelUnstakeTokenOperation,
};
export default TokensUtils;
